/*
 * @Description: 报名公用js
 * @Author: 山淑兰
 * @Date: 2019-11-28 11:22:44
 * @LastEditTime: 2020-07-15 17:46:36
 * @LastEditors: 山淑兰
 */
import wxShare from './wxShare'

export default class meeting {
    /**
     * @Description: 会议基本信息
     * @param: {object} opt 会议唯一标识m
     * @param: {object} vueThis vue中的this
     */
    async init(opt, vueThis) {
        //pc端打开页面则跳转pc端
        let isMobile = this.is_Mobile()
		console.log(vueThis.$route.path.indexOf('liveinfo'))
        if ( !isMobile) {
            if (( vueThis.$route.path.indexOf('guest') == -1 && vueThis.$route.path.indexOf('place') != -1) ||
                vueThis.$route.path.indexOf('scheduleList') != -1 ||
                vueThis.$route.path.indexOf('previewInfo') != -1) {
                let _params = window.location.href.split('?')[1]
                window.location.href = `https://mp.weiqihd.com/pweb/#/schedules?${_params}`
            } else if (vueThis.$route.path.indexOf('guest') != -1 && vueThis.$route.path.indexOf('place') != -1) {
                let _params = window.location.href.split('?')[1]
                window.location.href = `https://mp.weiqihd.com/pweb/#/guest?${_params}`
            }else if (vueThis.$route.path.indexOf('guest') != -1 && vueThis.$route.path.indexOf('scheduleList') != -1) {
                let _params = window.location.href.split('?')[1]
                window.location.href = `https://mp.weiqihd.com/mpweb/#/guest/scheduleList/?${_params}`
            }else if (vueThis.$route.path.indexOf('guest') != -1 && vueThis.$route.path.indexOf('searchList') != -1) {
                let _params = window.location.href.split('?')[1]
                window.location.href = `https://mp.weiqihd.com/mpweb/#/guest/searchList/?${_params}`
            }  else if (vueThis.$route.path.indexOf('liveInfo') != -1 || vueThis.$route.path.indexOf('liveinfo') != -1 ) {
                let _params = window.location.href.split('?')[1]
                window.location.href = `https://mp.weiqihd.com/pweb/#/liveInfo?${_params}`
            } else if (vueThis.$route.path.indexOf('photoList') != -1 || vueThis.$route.path.indexOf('photoDetail') != -1) {
                let _params = window.location.href.split('?')[1]
                window.location.href = `https://mp.weiqihd.com/pweb/#/photoList?${_params}`
            } else if (vueThis.$route.path.indexOf('meeting/details') != -1 ) {
                let _params = window.location.href.split('?')[1]
                window.location.href = `https://mp.weiqihd.com/mpweb/#/meeting/details/?${_params}`
            } else if (vueThis.$route.path.indexOf('elogin') != -1 ) {
                let _params = window.location.href.split('?')[1]
                window.location.href = `https://mp.weiqihd.com/mpweb/#/elogin?${_params}`
            }else if (vueThis.$route.path.indexOf('initPage') != -1 ) {
                let _params = window.location.href.split('?')[1]
                window.location.href = `https://mp.weiqihd.com/mpweb/#/initPage?${_params}`
            } else if (vueThis.$route.path.indexOf('scanCheckin') != -1 ) {
                let _params = window.location.href.split('?')[1]
                //window.location.href = `https://mp.weiqihd.com/mpweb/#/meeting/details/?${_params}`
            } else {
                let _params = window.location.href.split('?')[1]
                window.location.href = `https://mp.weiqihd.com/pweb/#/?${_params}`
            }
        }
        // if (!isMobile) {
        // //if (!isMobile && vueThis.$route.path.indexOf('meeting') == -1) {
        //   let _params = window.location.href.split('?')[1]
        //   window.location.href = `https://mp.weiqihd.com/pweb/#/?${_params}`
        // }
        // ---
        const m = opt
        let res
        try {
            res = await vueThis.$http.initMeetingInfo(m)
            document.title = res.MeetingTitle
            let link = window.location.href
            this.res = res
            if (res.Code === 3333) {
                vueThis.$notify({
                    message: res.Msg,
                    type: 'danger',
                })
            } else if (res.Code === 6001 && vueThis.$route.name != 'login') {
                vueThis.$router.push({
                    path: '/login',
                    query: vueThis.$route.query,
                })
            } else if (res.Code === 1000) {
                if( vueThis.$route.path.indexOf('liveinfo') != -1 || vueThis.$route.path.indexOf('liveInfo') != -1){
                    this.initShare(
                        vueThis,
                        '大会直播 - '+res.ShareTitle+'',
                        res.meetingdes,
                        link,
                        res.MeetingLogo,
                        opt.m
                    )
                }else if( vueThis.$route.path.indexOf('scheduleList') != -1  ||
                 vueThis.$route.path.indexOf('searchList') != -1 ||
                 vueThis.$route.path.indexOf('photoList') != -1 ||
                 vueThis.$route.path.indexOf('meeting/place') != -1 ){
                    this.initShare(
                        vueThis,
                        '会议日程 - '+res.ShareTitle+'',
                        res.meetingdes,
                        link,
                        res.MeetingLogo,
                        opt.m
                    )
                }else{
                    this.initShare(
                        vueThis,
                        res.ShareTitle,
                        res.meetingdes,
                        link,
                        res.MeetingLogo,
                        opt.m
                    )
                }
            }
        } catch (err) {
            console.log(err)
        }
        return res
    }
    /**
     * @Description: 获取当前登录账户报名信息接口
     */
    async GetSignMeetingUserByMu(opt, vueThis) {
        let res
        try {
            res = await vueThis.$http.GetSignMeetingUserByMu(opt)
            this.res = res
        } catch (err) {
            console.log(err)
        }
        return res
    }
    /**
     * @Description: 上传图片
     */
    async UploadPic(params, vueThis) {
        let res
        try {
            res = await vueThis.$http.UploadPic(params)
            this.res = res
        } catch (err) {
            console.log(err)
        }
        return res
    }
    /**
     * @title 通用时间戳转日期
     * @param {number} dates
     */
    changeTimeStamp(dates) {
        let date, year, month, day, Hour, minute, second
        date = new Date(dates)
        year = date.getFullYear()
        month = date.getMonth() + 1
        month = month < 10 ? '0' + month : month
        day = date.getDate()
        day = day < 10 ? '0' + day : day
        Hour = date.getHours()
        minute = date.getMinutes()
        minute = minute < 10 ? '0' + minute : minute
        second = date.getSeconds()
        return {
            year,
            month,
            day,
            Hour,
            minute,
            second,
        }
    }
    /**
     * @title 后台时间数据转日期
     * @param {any} dates
     */
    changeFormDate(dates) {
        let _date = dates.split('(')
        let _dates = Number(_date[1].split(')')[0])
        return this.changeTimeStamp(_dates)
    }
    /**
     *@description 返回小时和分钟
     */
    convertTime(time) {
        let end = time.split('(')[1].split(')')[0]
        // 将时间戳转时间格式
        let date = new Date(Number(end))
        let h = date.getHours()
        h = h < 10 ? '0' + h : h
        let m = date.getMinutes()
        m = m < 10 ? '0' + m : m
        return h + ':' + m
    }
    /**
     * @title 判断是否为移动端
     */
    isMobile() {
        if (navigator.userAgent.match(/mobile/i)) {
            return true
        }
    }

    /**
     * @description 正则匹配邮箱/手机号/身份证
     * @param {string} val 要匹配的字符串
     * @param {string} type 要匹配的是身份证、邮箱、手机号的标识
     * @param {object} ev 当前的input
     */
    regCheck(val, type, ev, vuethis) {
        let reg, msg
        if (type === 'ID') {
            reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
            msg = '请输入正确的身份证号!'
        } else if (type === 'Email') {
            //reg = /^([a-zA-Z]|[0-9])(\w)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
            //reg = /^[a-z0-9](\w|\.|-)*@([a-z0-9]+-?[a-z0-9]+\.){1,3}[a-z]{2,4}$/i
			reg = /^[^\s@]+@([^\s@.,]+\.)+[^\s@.,]{2,}$/
            msg = '请输入正确的邮箱!'
        } else if (type === 'tel') {
            reg = /^1[1-9]\d{9}$/
            msg = '请输入正确的手机号!'
        } else if (type === 'number') {
            reg = /^\d+$|^\d+[.]?\d+$/
            msg = '请输入有效数字!'
        }
        let reTel = reg.test(val)
        if (reTel === false) {
            vuethis.$notify({
                message: msg,
                type: 'danger',
            })
            ev.target.focus()
            return false
        } else {
            return true
        }
    }

    /**
     * @description 判断是否为对象
     */
    isObj(obj) {
        return (
            (typeof obj === 'object' || typeof obj === 'function') && obj !== null
        )
    }
    /**
     * @description 深拷贝
     */
    deepCopy(obj, hash = new WeakMap()) {
        if (hash.has(obj)) return hash.get(obj)
        let cloneObj = Array.isArray(obj) ? [] : {}
        hash.set(obj, cloneObj)
        for (let key in obj) {
            cloneObj[key] = this.isObj(obj[key]) ?
                this.deepCopy(obj[key], hash) :
                obj[key]
        }
        return cloneObj
    }
    /**
     * @description 微信分享
     */
    async initShare(vuethis, title, desc, link, imgUrl, mid) {
        try {
            const headRes = await vuethis.$http.csData({
                url: encodeURIComponent(
                    window.location.href.replace(location.hash, '')
                ),
                m: mid
            })
            const _Wx = new wxShare({
                opt: headRes,
            })
            _Wx.ready().then((wx) => {
                _Wx.share(title, desc, link, imgUrl)
                console.log(wx)
            })
        } catch (err) {
            console.log(err)
        }
    }
    /**
     * @description 解决微信端IOS下底部弹出下拉框收起后留白问题
     */
    blur() {
        document.documentElement.scrollTop = document.body.scrollTop =
            this.scrollTop() - 1
    }

    scrollTop() {
        if (document.documentElement.scrollTop) {
            return document.documentElement.scrollTop
        } else {
            return document.body.scrollTop
        }
    }
    on_blur() {
        setTimeout(() => {
            const scrollHeight =
                document.documentElement.scrollTop || document.body.scrollTop || 0
            window.scrollTo(0, Math.max(scrollHeight - 1, 0))
        }, 100)
    }
    /**
     *  判断是否是移动端
     */
    is_Mobile() {
        let ua = navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        if (ua) {
            return true
        } else {
            return false
        }
    }
}